import { render, staticRenderFns } from "./GDivider.vue?vue&type=template&id=080fcdf4&"
import script from "./GDivider.vue?vue&type=script&lang=js&"
export * from "./GDivider.vue?vue&type=script&lang=js&"
import style0 from "./GDivider.vue?vue&type=style&index=0&id=080fcdf4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports